export default "__VITE_ASSET__Dy8AQZ7H__"